export default __webpack_public_path__ + "static/media/gopi@2x.aec3218c.png";